import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Select from "react-select";
import "./twitterComp.css";
import { useSelector } from "react-redux";

const TwitterCreateDest = (props) => {
    const language = useSelector((state) => state.languagesState.languages);
    const [response, setResponse] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState();
    const [tags, setTags] = useState([]);

    useEffect(() => {
        if (props.authData !== undefined && props.authData.status) {
            let install_id = props?.authData?.data?.install_id;
            let response = props?.authData?.data;
            if (props.setTwInstallId) {
                props.setTwInstallId(install_id);
            }
            setResponse(response);
        }
    }, [props?.authData]);

    const handleSelectAccount = (e) => {
        if (e) {
            setSelectedAccount(e);
            if (props.setTwAccountId) {
                props.setTwAccountId(e?.account_id);
            }
            if (props.setTwPixelId) {
                props.setTwPixelId(e?.pixel?.id);
            }
            setTags(e?.pixel?.web_tags);
        }
    };

    return (
        <div>
            {response?.installation_completed === false &&
                response?.details?.message !== undefined && (
                    <div className="mb-3">
                        <div
                            class="alert alert-danger"
                            role="alert"
                            dangerouslySetInnerHTML={{
                                __html: response?.details?.message,
                            }}
                        ></div>
                    </div>
                )}
            {response?.pixels && response?.pixels.length > 0 && (
                <div className="mb-3">
                    <Form.Group controlId="formGroup">
                        <Form.Label>
                            {language?.destination?.select_account ??
                                "Select Account"}
                        </Form.Label>
                        <Select
                            onChange={(e) => handleSelectAccount(e)}
                            placeholder="Accounts"
                            options={
                                response?.pixels &&
                                response?.pixels.length > 0 &&
                                response?.pixels
                            }
                            getOptionValue={(option) =>
                                `${option["account_id"]}`
                            }
                            getOptionLabel={(option) =>
                                `${option["account_name"]}`
                            }
                            value={selectedAccount}
                        />
                    </Form.Group>
                </div>
            )}
            {selectedAccount &&
                !selectedAccount?.has_pixel &&
                selectedAccount?.details?.message !== undefined && (
                    <div className="mb-3">
                        <div
                            class="alert alert-danger"
                            role="alert"
                            dangerouslySetInnerHTML={{
                                __html: selectedAccount?.details?.message,
                            }}
                        ></div>
                    </div>
                )}
            {tags && tags.length > 0 && (
                <div className="mb-3 mxh-200px">
                    <Table striped bordered hover responsive size="sm">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>NAME</th>
                                <th>TYPE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tags.map((tag) => {
                                return (
                                    <tr>
                                        <td style={{ minWidth: "150px" }}>
                                            {tag.tag_id}
                                        </td>
                                        <td>{tag.tag_name}</td>
                                        <td>{tag.tag_type}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            )}
            {selectedAccount &&
                !selectedAccount?.pixel?.has_web_tags &&
                selectedAccount?.pixel?.details?.message !== undefined && (
                    <div className="mb-3">
                        <div
                            class="alert alert-danger"
                            role="alert"
                            dangerouslySetInnerHTML={{
                                __html: selectedAccount?.pixel?.details
                                    ?.message,
                            }}
                        ></div>
                    </div>
                )}
        </div>
    );
};

export default TwitterCreateDest;
